import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["helperText", "variant", "disabled", "children", "legend", "helperContent", "errorFieldNames", "errorText"];
import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { useFormikContext } from 'formik';
import { VisuallyHidden } from '@figure/frontlib-accessibility';
import { IS_DEV } from '../../../constants';
import { Div, StyledFieldset } from '../../Styled';
import { cssByBreakpoint } from '../../../styling';
import { accessPropertyByDotNotationString, toAlphanumericDashString } from '../../../utils';
import { labelCss } from '../Label';
import { HelperText } from '../../text';
var Legend = /*#__PURE__*/styled.legend.withConfig({
  displayName: "Fieldset__Legend",
  componentId: "sc-196ihmo-0"
})(["display:block;user-select:none;", ";", ""], labelCss, function (_ref) {
  var $helperContent = _ref.$helperContent;
  return $helperContent && cssByBreakpoint([css(["float:none;"]), css(["", ""], $helperContent && css(["float:left;"]))]);
});
/**
 * A `<legend>` must be the first child of a `<fieldset>`.
 * Flexbox cannot be used with a `<legend>` element in Safari so floats are used to position the `<legend>` and `helperContent`.
 */

var Fieldset = function Fieldset(_ref2) {
  var helperText = _ref2.helperText,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'primary' : _ref2$variant,
      disabled = _ref2.disabled,
      children = _ref2.children,
      legend = _ref2.legend,
      helperContent = _ref2.helperContent,
      errorFieldNames = _ref2.errorFieldNames,
      _ref2$errorText = _ref2.errorText,
      externalErrorText = _ref2$errorText === void 0 ? '' : _ref2$errorText,
      rest = _objectWithoutProperties(_ref2, _excluded);

  if (IS_DEV && !legend) console.error("Fieldsets require legend text.");

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      errorText = _useState2[0],
      setErrorText = _useState2[1];

  var _useFormikContext = useFormikContext(),
      errors = _useFormikContext.errors;

  useEffect(function () {
    setErrorText(errorFieldNames ? errorFieldNames.reduce(function (err, name) {
      var error = accessPropertyByDotNotationString(errors, name);
      if (error) return error;
      return err;
    }, '') : '');
  }, [errors, errorFieldNames]);
  return /*#__PURE__*/React.createElement(StyledFieldset, rest, /*#__PURE__*/React.createElement(Legend, {
    $helperContent: !!helperContent,
    $variant: variant,
    $disabled: disabled,
    "data-test-id": toAlphanumericDashString("".concat(legend))
  }, legend, helperText && /*#__PURE__*/React.createElement(HelperText, {
    disabled: disabled,
    className: "description",
    $css: css(["margin-top:8px;"])
  }, helperText), (errorText || externalErrorText) && /*#__PURE__*/React.createElement(VisuallyHidden, null, " ", errorText || externalErrorText)), helperContent && helperContent, helperContent && /*#__PURE__*/React.createElement(Div, {
    $css: css(["clear:both;"])
  }), /*#__PURE__*/React.createElement(Div, {
    className: "spacer",
    $css: css(["margin-bottom:16px;"])
  }), children);
};

export default Fieldset;